<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div
      class="flex justify-start divide-x-1.5 bg-white mx-3 my-5 items-center"
    >
      <router-link
        :to="getRouterLink(tab)"
        v-for="(tab, index) in filteredTabs"
        :key="index"
        :class="{
          'bg-primary text-white': selectedTab === tab.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ tab.name }}
      </router-link>
    </div>

    <mine v-if="selectedTab === 'My Time Off'" :key="mineKey"></mine>
    <team v-if="selectedTab === 'Team Time Off'" :key="teamKey"></team>
    <leave-planning
      v-if="selectedTab === 'Leave Plan'"
      :key="leavePlanningKey"
    ></leave-planning>
    <team-leave-plan
      v-if="selectedTab === 'Team Leave Plan'"
      :key="teamLeavePlanningKey"
    ></team-leave-plan>
    <bulk-upload
      v-if="selectedTab === 'Bulk Upload'"
      :key="bulkUploadKey"
    ></bulk-upload>
    <timeOffBalances
      v-if="selectedTab === 'Timeoff Balances'"
      :key="timeOffBalancesKey"
    ></timeOffBalances>
  </div>
</template>

<script>
import mine from '@/components/timeoff/mine.vue';
import team from '@/components/timeoff/team.vue';
import bulkUpload from '@/components/timeoff/timeoffBulkUpload.vue';
import timeOffBalances from '@/components/timeoff/timeoffBalances.vue';
import leavePlanning from '@/components/timeoff/leavePlanning.vue';
import TeamLeavePlan from '@/components/timeoff/teamLeavePlan.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'TimeOff',
  components: {
    mine,
    team,
    bulkUpload,
    timeOffBalances,
    leavePlanning,
    TeamLeavePlan,
  },
  data() {
    return {
      selectedTab: '',
      mineKey: 0,
      teamKey: 0,
      bulkUploadKey: 0,
      timeOffBalancesKey: 0,
      leavePlanningKey: 0,
      teamLeavePlanningKey: 0,
      tabs: [
        { name: 'My Time Off', route: 'mine' },
        { name: 'Team Time Off', route: 'team' },
        { name: 'Bulk Upload', route: 'bulk-upload' },
        { name: 'Timeoff Balances', route: 'timeoff-balances' },
        { name: 'Leave Plan', route: 'leave-planning' },
        { name: 'Team Leave Plan', route: 'team-leave-planning' },
      ],
    };
  },
  computed: {
    ...mapGetters(['getOrganization', 'getUserType', 'getUserRole']),
    filteredTabs() {
      const role = this.getUserRole?.toLowerCase();
      if (role === 'hrmanager') return this.tabs;
      return this.tabs.filter(
        (tab) =>
          !['Bulk Upload', 'Timeoff Balances', 'Team Leave Plan'].includes(
            tab.name
          )
      );
    },
  },
  created() {
    this.resolveTabFromRouteOrHash();
  },
  methods: {
    getRouterLink(tab) {
      return {
        name: 'timeoff',
        params: {
          type: tab.route,
          ...(this.getUserType?.toLowerCase() !== 'hr manager' && {
            company: this.getOrganization,
          }),
        },
        hash: `#${tab.route}`, // optional: helps maintain deep-linking
      };
    },

    resolveTabFromRouteOrHash() {
      const hash = this.$route.hash?.replace('#', '');
      const param = this.$route.params.type;

      const routeTab = this.tabs.find((tab) => tab.route === param);
      const hashTab = this.tabs.find((tab) => tab.route === hash);

      const active = hashTab || routeTab;

      this.selectedTab = active ? active.name : 'My Time Off';
    },
  },
  watch: {
    $route(to) {
      const tabMap = {
        'My Time Off': 'mineKey',
        'Team Time Off': 'teamKey',
        'Bulk Upload': 'bulkUploadKey',
        'Timeoff Balances': 'timeOffBalancesKey',
        'Leave Plan': 'leavePlanningKey',
        'Team Leave Plan': 'teamLeavePlanningKey',
      };

      this.resolveTabFromRouteOrHash();

      const currentTab = this.tabs.find(
        (tab) =>
          tab.route === to.params.type ||
          tab.route === to.hash?.replace('#', '')
      );
      if (currentTab && tabMap[currentTab.name]) {
        this[tabMap[currentTab.name]]++;
      }
    },
  },
};
</script>
